import Head from 'next/head'
import { plainToInstance } from 'class-transformer'
import { Waypoint } from 'react-waypoint'

import { Container } from '@components/Container'
import { ContainerStoryCard } from '@components/ContainerStoryCard'
import { StoryCard } from '@components/StoryCard'
import { LatestUpdateType } from '@models/latestUpdate/LatestUpdateType'
import { useDrawer } from '@hooks/contexts/DrawerContext/DrawerContext'
import { BookEnum } from '@interfaces/BookEnum'
import { StoryDetailReaderType } from '@models/story/StoryDetailReaderType'
import { LatestUpdatePageProps } from './interface'

export function LatestUpdatePage({
  data,
  handleFetchNextPage,
  bookType,
  isLoading,
}: LatestUpdatePageProps) {
  const storyDrawer = useDrawer({ drawer: 'story' })

  return (
    <Container className='mobile:px-[20px]'>
      <Head>
        <title>
          {bookType === undefined
            ? 'MaReads มารี้ด | อัปเดตใหม่ล่าสุด ไม่ตกเทรนด์ ฟินทุกวันในจักรวาลใหม่ของนักอ่านนักเขียน'
            : bookType === BookEnum.NOVEL
            ? 'MaReads มารี้ด | อ่านนิยายรายตอนอัปเดตใหม่ล่าสุด ไม่ตกเทรนด์ ฟินทุกวันในจักรวาลใหม่ของนักอ่านนักเขียน'
            : 'MaReads มารี้ด | อ่านการ์ตูนอัปเดตใหม่ล่าสุด ไม่ตกเทรนด์ ฟินทุกวันในจักรวาลใหม่ของนักอ่านนักเขียน'}
        </title>
      </Head>

      <ContainerStoryCard
        title={
          bookType === undefined
            ? 'อัปเดตล่าสุด'
            : bookType === BookEnum.NOVEL
            ? 'นิยายอัปเดตล่าสุด'
            : 'การ์ตูนอัปเดตล่าสุด'
        }
        total={Math.min(data?.pages[0]?.total || 0, 200)}
        isLoading={isLoading}
      >
        {data?.pages.map(page =>
          page?.data.map((item: LatestUpdateType) => (
            <StoryCard
              key={item.id}
              id={item.id}
              title={item.title}
              isShowBookPromotion={item.hasSalePromotions}
              buyAllChaptersPromotion={item.buyAllChaptersPromotion}
              bookChapterCampaignHeader={item.bookChapterCampaignHeader}
              readFreePromotion={item.readFreePromotion}
              bookBadges={item.bookBadges}
              imageUrl={item.coverResizeImgPath || item.coverImgPath}
              penName={item.penName?.firstPenName}
              slug={item.penName?.user?.profilePageSlug}
              content={item.cover}
              category={item.category?.name}
              tags={item.tags}
              chapter={item.chapterCount}
              view={item.viewCount}
              chat={item.commentCount}
              like={item.likeCount}
              isLiked={item.isLiked}
              isEnded={item.isEnded}
              bookType={item.bookType}
              categoryId={item.category?.id}
              handleClickStoryCard={() => {
                storyDrawer.show({
                  bookId: item.id,
                  initialData: plainToInstance(StoryDetailReaderType, {
                    id: item.id,
                    coverImgPath: item.coverImgPath,
                    title: item.title,
                    writingType: item.writingType,
                    publishedAt: item.publishedAt,
                    cover: item.cover,
                    viewCount: item.viewCount,
                    commentCount: item.commentCount,
                    likeCount: item.likeCount,
                    publishedChapterCount: item.chapterCount,
                    penName: item.penName,
                    category: item.category,
                    bookType: item.bookType,
                    tags: item.tags,
                    rating: {
                      name: '',
                    },
                    isEnded: item.isEnded,
                    isEpub: item.isEpub,
                    isPdf: item.isPdf,
                    isLiked: item.isLiked,
                  }),
                })
              }}
            />
          ))
        )}
      </ContainerStoryCard>
      {data &&
        data.pages.length &&
        data.pages[0].data.length !== 0 &&
        !isLoading && <Waypoint onEnter={handleFetchNextPage} />}
    </Container>
  )
}
